import * as React from "react";
import { SVGProps, memo } from "react";

const SvgCheckCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.771 11.896 6.73 9.854a.659.659 0 0 0-.938.02.623.623 0 0 0-.187.46c0 .18.063.333.188.458l2.542 2.563a.6.6 0 0 0 .437.187.6.6 0 0 0 .438-.188l4.979-4.979a.659.659 0 0 0 .208-.479.659.659 0 0 0-.698-.656.673.673 0 0 0-.469.198l-4.458 4.458Zm1.23 6.438a8.063 8.063 0 0 1-3.23-.657 8.452 8.452 0 0 1-2.656-1.791 8.452 8.452 0 0 1-1.792-2.656A8.063 8.063 0 0 1 1.667 10c0-1.152.219-2.236.656-3.25a8.328 8.328 0 0 1 1.792-2.646 8.542 8.542 0 0 1 2.656-1.78 8.063 8.063 0 0 1 3.23-.657c1.152 0 2.235.219 3.25.656a8.416 8.416 0 0 1 2.645 1.781 8.415 8.415 0 0 1 1.781 2.646 8.115 8.115 0 0 1 .657 3.25 8.063 8.063 0 0 1-.657 3.23 8.541 8.541 0 0 1-1.78 2.656 8.328 8.328 0 0 1-2.647 1.791 8.115 8.115 0 0 1-3.25.657Z"
      fill="#4DB27F"
    />
  </svg>
);

const Memo = memo(SvgCheckCircle);

export default Memo;
